/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './assessment-answer.reducer';

export const AssessmentAnswerDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const assessmentAnswerEntity = useAppSelector(state => state.assessmentAnswer.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="assessmentAnswerDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.assessmentAnswer.detail.title">AssessmentAnswer</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.assessmentAnswer.id">Id</Translate>
            </span>
          </dt>
          <dd>{assessmentAnswerEntity.id}</dd>
          <dt>
            <span id="answer">
              <Translate contentKey="tinyMedicRestApp.assessmentAnswer.answer">Answer</Translate>
            </span>
          </dt>
          <dd>{assessmentAnswerEntity.answer ? 'true' : 'false'}</dd>
          <dt>
            <span id="comment">
              <Translate contentKey="tinyMedicRestApp.assessmentAnswer.comment">Comment</Translate>
            </span>
          </dt>
          <dd>{assessmentAnswerEntity.comment}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.assessmentAnswer.active">Active</Translate>
            </span>
          </dt>
          <dd>{assessmentAnswerEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.assessmentAnswer.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{assessmentAnswerEntity.cursor}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.assessmentAnswer.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{assessmentAnswerEntity.lastupdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.assessmentAnswer.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{assessmentAnswerEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.assessmentAnswer.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{assessmentAnswerEntity.timestampentry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.assessmentAnswer.question">Question</Translate>
          </dt>
          <dd>{assessmentAnswerEntity.question ? assessmentAnswerEntity.question.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.assessmentAnswer.patient">Patient</Translate>
          </dt>
          <dd>{assessmentAnswerEntity.patient ? assessmentAnswerEntity.patient.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.assessmentAnswer.preAssessment">Pre Assessment</Translate>
          </dt>
          <dd>{assessmentAnswerEntity.preAssessment ? assessmentAnswerEntity.preAssessment.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/assessment-answer" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/assessment-answer/${assessmentAnswerEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default AssessmentAnswerDetail;
